module.exports = __webpack_public_path__ + "static/img/1.5c1a5e96.png";